/**
* Jump Link Header JS
* -----------------------------------------------------------------------------
*
* All the JS for the Jump Link Header component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'jump-link-header',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.jump-link-header__links' ).each( function( key, val ) {
        let navHeight = $( '.navbar' ).height();

        if ( $( 'body' ).hasClass( 'admin-bar' ) ) {
          navHeight += $( '#wpadminbar' ).height();
        }

        const linksPosition = $( this ).position().top;
        console.log( linksPosition );
        const mainHeight = $( 'main' ).height();
        const pinAmount = mainHeight - linksPosition;

        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: this,
            pin: this,
            pinSpacing: false,
            start: 'top ' + navHeight,
            end: '+=' + pinAmount,
            scrub: 0,
            // markers: true,
          },
        } );

        // if the window is mobile, add aria-hidden to the jump links wrapper to make it more accessible with the dropdown trigger
        if ( window.innerWidth < 1024 ) {
          $( this ).find( 'ul' ).attr( 'aria-hidden', true );
        }

        // if the window is mobile, add aria-hidden to the jump links wrapper to make it more accessible with the dropdown trigger
        $( window ).on( 'resize', function() {
          if ( window.innerWidth < 1024 ) {
            $( this ).find( 'ul' ).attr( 'aria-hidden', true );
          } else {
            $( this ).find( 'ul' ).removeAttr( 'aria-hidden' );
          }
        } );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'jump-link-header', COMPONENT );
} )( app );
